// Learn more on: https://date-fns.org
export const DEFAULT_INPUT_TIME_FORMAT = 'hh:mm a';

export const DEFAULT_TIME_FORMAT = 'h:mm a';
